export default __webpack_public_path__ + "static/media/female_bowel-01.c4245bed.png";